'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { ChevronChevronNormalDown } from '@s7/icons';

var IDENT_ACCORDION_CONTROL = "AccordionItemControl";
var ACCORDION_CHEVRON_POSITIONS = [
    "left",
    "right"
];
var controlDefaultProps = {
    chevronPosition: "right",
    chevronSize: 24,
    transitionDuration: 200,
    chevron: /*#__PURE__*/ jsx(ChevronChevronNormalDown, {})
};

export { ACCORDION_CHEVRON_POSITIONS, IDENT_ACCORDION_CONTROL, controlDefaultProps };
